import { jsx as o } from "react/jsx-runtime";
import { forwardRef as I, Button as z } from "@chakra-ui/react";
import { useMemo as u } from "react";
import { getIconSizeFromButtonSize as h } from "./helper.js";
import { Icon as n } from "../icon/icon.js";
const S = I((c, s) => {
  const { children: m, variant: a = "secondary", size: i = "md", href: d, isSelected: f, leftIcon: t, rightIcon: e } = c, r = u(() => h(i), [i]);
  return d ? /* @__PURE__ */ o(
    z,
    {
      as: "a",
      href: d,
      size: i,
      variant: a,
      ...c,
      ref: s,
      "aria-pressed": f,
      leftIcon: t ? /* @__PURE__ */ o(n, { size: r, icon: t }) : void 0,
      rightIcon: e ? /* @__PURE__ */ o(n, { size: r, icon: e }) : void 0,
      children: m
    }
  ) : /* @__PURE__ */ o(
    z,
    {
      size: i,
      variant: a,
      ref: s,
      ...c,
      "aria-pressed": f,
      leftIcon: t ? /* @__PURE__ */ o(n, { size: r, icon: t }) : void 0,
      rightIcon: e ? /* @__PURE__ */ o(n, { size: r, icon: e }) : void 0,
      children: m
    }
  );
});
export {
  S as Button
};
